<div class="title-wrapper grit-title-wrapper">
  <ng-content select="[pgTitle], [gritTitle]"></ng-content>
  <div class="flex-spacer"></div>
  <div class="icon-bg">
    <div class="bg-fill">
      <pg-icon [size]="18">done</pg-icon>
    </div>
  </div>
</div>
<div class="subtitle-wrapper grit-subtitle-wrapper" #subtitleWrapper>
  <ng-content select="[pgSubtitle], [gritSubtitle]"></ng-content>
</div>
